import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  ChequeGiroClearingLiteModel,
  ChequeGiroClearingModel,
  getChequeGiroClearingInput,
  getChequeGiroClearingsInput,
} from './model';

export function useGetChequeGiroClearings(
  input?: getChequeGiroClearingsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ChequeGiroClearingLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ChequeGiroClearingLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getChequeGiroClearings', input?.params],
      () =>
        QueryFetchFunction({
          url: `cheque-notes`,
          params: input?.params,
        }),
      options,
    ),
    ChequeGiroClearingLiteModel,
  );
}

export function useGetChequeGiroClearing(
  input?: getChequeGiroClearingInput,
  options?: UseQueryOptions<ApiResult<ChequeGiroClearingModel>, ApiError>,
): UseQueryResult<ApiResult<ChequeGiroClearingModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getChequeGiroClearing', input?.id],
      () =>
        QueryFetchFunction({
          url: `cheque-notes/${input?.id}`,
        }),
      options,
    ),
    ChequeGiroClearingModel,
  );
}

export function getChequeGiroClearingsKey(input?: getChequeGiroClearingsInput) {
  return ['getChequeGiroClearings', input?.params];
}

export function getChequeGiroClearingKey(input?: getChequeGiroClearingInput) {
  return ['getChequeGiroClearing', input?.id];
}
